/**
 * Query key utilities for organization tax rates and their assignments
 */
export const taxRatesKeys = {
  findAll: () => ["tax-rates", "findAll"] as const,
} as const

export const taxRateAssignmentsKeys = {
  getAssignments: () => ["tax-rates", "getAssignments"] as const,
} as const
